import Layout from '@/layout';
var newFinancialRouter = {
  path: '/newFinancial',
  component: Layout,
  redirect: '/newFinancial',
  name: 'newFinancial',
  meta: {
    title: '新财务',
    icon: 'clipboard'
  },
  children: [{
    path: 'commission',
    component: function component() {
      return import('@/views/newFinancial/commission');
    },
    name: 'Commission',
    meta: {
      title: '佣金记录',
      icon: ''
    }
  }, {
    path: 'withdraw',
    component: function component() {
      return import('@/views/newFinancial/withdraw');
    },
    name: 'Withdraw',
    meta: {
      title: '提现申请',
      icon: ''
    }
  }]
};
export default newFinancialRouter;